import { useAtomValue } from 'jotai';
import { FC } from 'react';

import { participantsAtom, remoteScreenShareParticipantAtom } from '../../video-sdk';
import { isWhiteboardModeAtom } from '../messages/state';
import { LocalScreenShare } from './LocalScreenShare';
import { MediaShareLayout, MediaShareLayoutProps } from './MediaShareLayout';
import { RemoteScreenShare } from './RemoteScreenShare';

export function MediaShareLayoutWrapper({
  thumbnail,
  remoteParticipantComponent: RemoteParticipantComponent,
  whiteboardComponent: WhiteboardComponent,
}: Pick<MediaShareLayoutProps, 'thumbnail' | 'remoteParticipantComponent'> & {
  whiteboardComponent: FC;
}) {
  const participants = useAtomValue(participantsAtom);
  const remoteScreenShareParticipant = useAtomValue(remoteScreenShareParticipantAtom);
  const isWhiteboardMode = useAtomValue(isWhiteboardModeAtom);

  const ScreenShareComponent = (
    <>
      <LocalScreenShare />
      {remoteScreenShareParticipant && <RemoteScreenShare />}
    </>
  );

  return (
    <MediaShareLayout
      remoteParticipants={participants}
      remoteScreenShareParticipant={remoteScreenShareParticipant}
      remoteParticipantComponent={RemoteParticipantComponent}
      thumbnail={thumbnail}
      sharedMediaComponent={isWhiteboardMode.value ? <WhiteboardComponent /> : ScreenShareComponent}
    />
  );
}
